import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DEFAULT_CURRENCY_CODE, enableProdMode, inject, isDevMode, LOCALE_ID, provideAppInitializer, provideZonelessChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, TitleStrategy as AngularTitleStrategy, withInMemoryScrolling } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import Faye from 'faye/src/faye_browser';
import { CookieService } from 'ngx-cookie-service';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { environment } from '../../common/environment/environment';
import { ENVIRONMENT } from '../../common/environment/environment.config';
import { SwitchUserInterceptor } from '../../common/interceptors/switch-user.interceptor';
import { AuthService } from '../../common/services/auth.service';
import { TitleStrategy } from '../../common/services/title.strategy';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routing';

if ('production' === environment.name) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideEnvironmentNgxMask({showMaskTyped: false}), // TODO: https://github.com/JsDaddy/ngx-mask/issues/1590
        provideRouter(routes, withInMemoryScrolling({scrollPositionRestoration: 'disabled'})),
        provideZonelessChangeDetection(),
        provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000',
        }),
        provideHttpClient(withInterceptorsFromDi()),
        {provide: HTTP_INTERCEPTORS, useClass: SwitchUserInterceptor, multi: true},
        {provide: ENVIRONMENT, useValue: environment},
        CookieService,
        {provide: 'Faye', useValue: new Faye.Client(`${environment.fayeUrl}/socket`)},
        {provide: AngularTitleStrategy, useClass: TitleStrategy},
        provideAppInitializer(() => inject(AuthService).initRedirection()),
        {provide: LOCALE_ID, useValue: 'fr-FR'},
        {provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR'},
    ]})
    .catch(err => console.error(err));
